var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "narrator-calendar-btn",
      on: {
        mouseenter: function ($event) {
          _vm.onHover = true
        },
        mouseleave: function ($event) {
          _vm.onHover = false
        },
      },
    },
    [
      _c(
        "IButton",
        {
          staticClass: "btn-ghost flex-wrap",
          class: { active: _vm.isCalendarActive || _vm.onHover },
          attrs: { id: "IStagingCalendarBtn" },
          on: { click: _vm.showCalendar },
        },
        [_c("i", { staticClass: "isif isif-calendar" })]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "narrator-calendar-tip",
          class: [_vm.onHover ? "hover" : ""],
        },
        [_c("span", [_vm._v(_vm._s(_vm.$t("booking.reserve")))])]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }